import React from 'react';
import './FormField.css';

/**
 * FormField – wraps label + input/select/textarea
 * @param {string} type - 'text' | 'number' | 'date' | 'tel' | 'email' | 'select' | 'textarea'
 * @param {Array}  options - for type='select'
 */
export default function FormField({ label, type = 'text', placeholder, options = [], rows = 3, value, onChange, name, list }) {
  return (
    <div className="form-field">
      {label && <label className="form-field__label">{label}</label>}

      {type === 'select' ? (
        <select className="form-field__control" name={name} value={value} onChange={onChange}>
          <option value="">Select {label}</option>
          {options.map((opt) =>
            typeof opt === 'string'
              ? <option key={opt} value={opt}>{opt}</option>
              : <option key={opt.value} value={opt.value}>{opt.label}</option>
          )}
        </select>
      ) : type === 'textarea' ? (
        <textarea
          className="form-field__control"
          rows={rows}
          placeholder={placeholder || (label ? `Enter ${label}` : '')}
          name={name}
          value={value}
          onChange={onChange}
        />
      ) : (
        <input
          className="form-field__control"
          type={type}
          placeholder={placeholder || (label ? `Enter ${label}` : '')}
          name={name}
          value={value}
          list={list}
          onChange={onChange}
        />
      )}
    </div>
  );
}
